import React from 'react';
import styled from 'styled-components';
import { frontdoorTheme } from '../theme';

interface Props {
  title?: any;
  maxWidth?: number;
}

const Fieldset: React.FC<React.PropsWithChildren<Props>> = ({ children, maxWidth = 700, title }) => (
  <div style={{ maxWidth, margin: '50px auto' }}>
    <StyledContainer>
      {title && <StyledLegend>{title}</StyledLegend>}
      <div style={{ padding: 32, flex: 1 }}>{children}</div>
    </StyledContainer>
  </div>
);

export default Fieldset;

const StyledContainer = styled.fieldset`
  border: 0.5px solid #e2e3e4;
  border-radius: 6px;
  padding: 0px;
  margin: 0px;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  box-shadow: 0 3px 10px 1px rgb(0 0 0 / 10%);
`;

const StyledLegend = styled.legend`
  color: ${frontdoorTheme.palette.text.secondary};
  font-size: ${frontdoorTheme.typography.fontSize}px;
  font-weight: 500;
  margin: 0 auto;
  padding: 2px 4px 0 4px;
  text-transform: uppercase;
`;
